import React from "react";
import { IGlossaryIconCategory, IGlossaryIconModel } from "../models/glossary-icons-block-models";
import GlossaryIconCategory from "./glossary-icon-category";

interface IProps {
    glossaryIcons: IGlossaryIconModel[];
}

//Display glossary icons grouped by category.
const GlossaryIconCategories = (props: IProps) => {
    if (props.glossaryIcons && props.glossaryIcons.length > 0) {
        let distinctCategories = props.glossaryIcons.map(x => x.iconCategory).filter((value, index, self) => self.indexOf(value) === index);
        if (distinctCategories && distinctCategories.length > 0) {
            let categoriesWithIcons = distinctCategories.map((category) => {
                let glossaryIconsForCategory = props.glossaryIcons.filter(x => x.iconCategory === category);

                let glossaryIconCategory: IGlossaryIconCategory = {
                    iconCategory: category,
                    glossaryIcons: glossaryIconsForCategory
                } 

                return glossaryIconCategory;
            });

            return (
                <div className="glossary-block-panel-container">
                    {categoriesWithIcons.map(category =>
                        <GlossaryIconCategory glossaryIconCategory={category} id={category.iconCategory.toString().replace(/\s/g, '')} />
                    )}
                </div>
            )
        }   
    }

    return (
        <></>
    )
}

export default GlossaryIconCategories